export enum DocumentType {
    url = "url",
    s3 = "s3"
}